export default {"src":"/_next/static/media/the_volte_logo_black.aa1c8b7c.svg","height":329,"width":1314};